import React from "react";
import { PropertyEditorInteger, PropertyEditorIntegerInterface } from "../PropertyEditorInteger";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextData implements PropertyEditorIntegerInterface {
    editObject: object = {};
    hint: string = "hint";
    label: string = "Integer Editor";

    propertyName: string = "textValue";
    requiredText: string = "required text";
}

let args = new TextData();

class TextData2 implements PropertyEditorIntegerInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "textValue"), new ValidationIssue("issue2", "textValue")];
        },
    };
    hint: string = "hint";
    label: string = "Integer Editor";

    propertyName: string = "textValue";
    requiredText: string = "required text";
}

let args2 = new TextData2();

export const IntegerPropertyEditor = [
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorInteger
                    {...args}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName);
                        logCallback(d + "");
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Integer",
        "Default",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorInteger
                    {...args}
                    error={"error text"}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName);
                        logCallback(d + "");
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Integer",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorInteger
                    {...args2}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName);
                        logCallback(d + "");
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Integer",
        "Validation Provider",
    ),
];
